module.exports = __webpack_public_path__ + "img/brasao-sp.a5fe11da.svg";